import { Checkbox } from "@circleco/compass/components/Checkbox";
import { Controller, useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";
import type { CreateSubmissionPayload } from "@/react/api/submissionsApi";

import { useBlocksContext } from "../contexts/BlocksContext";

interface MarketingConsentCheckboxProps {
  defaultChecked: boolean;
  message: string | null;
}

export const MarketingConsentCheckbox = ({
  defaultChecked,
  message,
}: MarketingConsentCheckboxProps) => {
  const { control } = useFormContext<CreateSubmissionPayload>();
  const { useFormRenderingContext } = useBlocksContext();
  const { form } = useFormRenderingContext();

  if (!form.shows_marketing_consent_checkbox) return null;

  return (
    <Controller
      control={control}
      name="marketing_consent"
      defaultValue={defaultChecked}
      shouldUnregister
      rules={{
        required: form.marketing_consent_required
          ? t("settings.forms.errors.marketing_consent_required")
          : false,
      }}
      render={({
        field: { name, onChange, ref, value },
        fieldState: { error },
      }) => (
        <Checkbox
          name={name}
          checked={Boolean(value)}
          onCheckedChange={onChange}
          inputRef={ref}
          invalid={!!error}
          error={error?.message}
          label={
            message?.trim()
              ? message
              : t("settings.forms.marketing_consent_checkbox")
          }
          rootClassName="mb-4"
        />
      )}
    />
  );
};
